// extracted by mini-css-extract-plugin
export default {"loader":"mfr-X8a_Ftnp"};